<template>
  <v-autocomplete
    v-if="showSelect"
    :rules="requiredRules"
    v-model="value"
    :items="items"
    :label="_label"
    :multiple="multiple"
    v-bind="{...$attrs, ...$props}"
    v-on="$listeners"
  >
    <template v-slot:no-data v-text="$t('warnings.no_data_found')" />

    <v-icon @click="showSelect = !showSelect" color="primary" slot="append">mdi-plus</v-icon>
  </v-autocomplete>
  <v-text-field
    v-else
    :rules="requiredRules"
    v-model="value"
    :label="_label"
    v-bind="{...$attrs, ...$props}"
    v-on="$listeners"
  />
</template>
<script>
import FromToService from '../../services/FromToService'
import { requiredRules } from '../../utils/rules'

export default {
  name: 'CollectionsSelect',

  methods: {

    getItems () {
      FromToService.findAllCollections()
        .then(response => {
          if (response && response.data) {
            this.items = response.data
          } else {
            this.items = []
          }
        })
        .catch(error => {
          console.error(`${this.$t('warnings.error.occurred')} : ${error}`)
        })
    }
  },

  mounted () {
    this.getItems()
  },

  data: () => {
    return {
      items: [],
      showSelect: true
    }
  },

  computed: {
    requiredRules () {
      return this.required ? requiredRules(this.value) : []
    },
    _label () { return this.label != null ? null : this.$t('core.collectionsselect.list') }
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  }
}
</script>
